import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const ProductCardSkeleton = () => {
  return (
    <div className='itemProducts w-full items-center overflow-hidden'>
      <div className='image-thumb relative block w-full overflow-hidden rounded-t-sm'>
        <Skeleton
          duration={0.9}
          className=' w-full pt-[100%] text-[0px]'
          inline
        />
      </div>
      <div className='flex w-full flex-col flex-wrap bg-white pt-2 text-left'>
        <Skeleton duration={0.9} height={40} />
        <div className=' price-wrapper w-full'>
          <div className='sale-price flex items-center justify-between'>
            <Skeleton duration={0.9} height={32} width={150} />
          </div>
          <div className='originPrice flex-start flex items-center gap-x-1'>
            <Skeleton duration={0.9} height={48} width={180} />
          </div>
        </div>
        <Skeleton
          duration={0.9}
          height={34}
          inline
          className='mx-auto w-full'
          borderRadius={100}
        />
      </div>
    </div>
  )
}

export default ProductCardSkeleton
